import { Component, Input, OnDestroy } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';
import { CollectorListItem } from '../../../domain/collector-profile.model';
import { AlertService } from '../../../services/alert.service';
import { CollectorProfileService } from '../../../services/collector-profile.service';

@Component({
  selector: 'app-collector-metrics-card',
  templateUrl: './collector-metrics-card.component.html',
  styleUrls: [
    '../collector-card.shared.css',
    './collector-metrics-card.component.css'
  ]
})
export class CollectorMetricsCardComponent implements OnDestroy {
  @Input() collector!: CollectorListItem;
  @Input() readOnly = false;

  recalculating = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private collectorProfileService: CollectorProfileService,
    private alertService: AlertService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRecalculateScore(): void {
    if (this.readOnly || this.recalculating) {
      return;
    }
    this.recalculating = true;
    this.collectorProfileService
      .recalculateScore(this.collector.auth0Id)
      .pipe(
        tap((result) => {
          this.collector.score = result.score;
          this.collector.rejectionRate = result.rejectionRate;
          this.collector.reliability = result.reliability;
          this.collector.engagement = result.engagement;
        }),
        catchError((error) => {
          this.alertService.showError(
            error?.error?.message ?? 'Could not recalculate score'
          );
          return EMPTY;
        }),
        finalize(() => {
          this.recalculating = false;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
